import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { useAuth } from "./hooks/useAuth";
import { LoginScreen } from "./components/LoginScreen";
import { Dashboard } from "./components/Dashboard";
import "./index.css";

function AppInner() {
  const { state, signIn, logOut } = useAuth();

  if (state.status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-5 h-5 rounded-full border-2 border-foreground border-t-transparent animate-spin" />
      </div>
    );
  }

  if (state.status === "unauthenticated") {
    return (
      <>
        <LoginScreen onSignIn={signIn} />
        <Toaster />
      </>
    );
  }

  if (state.status === "unauthorized") {
    return (
      <>
        <LoginScreen onSignIn={signIn} isUnauthorized userEmail={state.user.email ?? undefined} />
        <Toaster />
      </>
    );
  }

  return (
    <>
      <Dashboard user={state.user} onSignOut={logOut} />
      <Toaster />
    </>
  );
}

export function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <AppInner />
    </ThemeProvider>
  );
}

export default App;
